import { Search as SearchIcon } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import debounce from "lodash.debounce";

export const Search = ({ placeholder, onSearch, disabled }) => {
	// debounce
	const debouncedSearch = debounce(onSearch, 300);

	return (
		<TextField
			variant="standard"
			placeholder={placeholder}
			sx={{ width: "100%" }}
			onChange={(e) => debouncedSearch({ query: e.target.value })}
			disabled={disabled}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				},
			}}
		/>
	);
};
